import React from 'react';
import { Code, Download } from '@mui/icons-material';

const SdkHero = () => {
    return (
        <section className="bg-gradient-to-br from-gray-900 to-amber-900 text-white py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <div className="flex justify-center mb-6">
                        <div className="p-4 bg-amber-500/20 rounded-2xl">
                            <Code className="text-6xl text-amber-400" />
                        </div>
                    </div>

                    <h1 className="text-5xl lg:text-6xl font-bold mb-6">
                        SDK Netikash
                    </h1>

                    <p className="text-xl text-amber-100 max-w-3xl mx-auto leading-relaxed">
                        Intégrez les paiements Netikash en quelques minutes avec nos SDK officiels.
                        Des bibliothèques optimisées pour chaque langage, avec une documentation complète
                        et des exemples pratiques.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                        <button className="bg-amber-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-amber-600 transition-all transform hover:-translate-y-1 shadow-lg hover:shadow-xl flex items-center space-x-3">
                            <Download />
                            <span>Télécharger le SDK</span>
                        </button>
                        <button className="border-2 border-amber-400 text-amber-400 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-amber-400 hover:text-white transition-all">
                            Voir sur GitHub
                        </button>
                    </div>

                    {/* Stats */}
                    <div className="grid md:grid-cols-4 gap-8 mt-16 max-w-4xl mx-auto">
                        <div className="text-center">
                            <div className="text-3xl font-bold mb-2">5+</div>
                            <div className="text-amber-200">Langages Supportés</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-bold mb-2">100%</div>
                            <div className="text-amber-200">Couverture API</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-bold mb-2">TypeScript</div>
                            <div className="text-amber-200">Typage Fort</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-bold mb-2">24/7</div>
                            <div className="text-amber-200">Support</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SdkHero;